import { render, staticRenderFns } from "./DepartCheckDetail.vue?vue&type=template&id=12025ab4&scoped=true"
import script from "./DepartCheckDetail.vue?vue&type=script&lang=js"
export * from "./DepartCheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12025ab4",
  null
  
)

export default component.exports